// extracted by mini-css-extract-plugin
module.exports = {"ResizeHandleOuter":"styles_ResizeHandleOuter__eTNnW","ResizeHandleInner":"styles_ResizeHandleInner__1dxXV","Icon":"styles_Icon__2Bf5v"};